const LEGACY_BUILD_START_STORAGE_KEY = 'legacy_socket_build_start_at';
const LEGACY_BUILD_START_MAX_AGE_MS = 2 * 60 * 60 * 1000;

const normalizeKeyPart = (value?: string | number | null) =>
  value == null || value === '' ? 'unknown' : String(value);

const getLegacyBuildStartKey = (projectId?: string | number | null, sessionId?: string | null) =>
  `${LEGACY_BUILD_START_STORAGE_KEY}:${normalizeKeyPart(projectId)}:${normalizeKeyPart(sessionId)}`;

const canUseSessionStorage = () => typeof window !== 'undefined' && Boolean(window.sessionStorage);

export const rememberLegacyBuildStart = (
  projectId?: string | number | null,
  sessionId?: string | null,
  startedAt = Date.now(),
) => {
  if (!canUseSessionStorage()) return;
  window.sessionStorage.setItem(getLegacyBuildStartKey(projectId, sessionId), String(startedAt));
};

export const getRememberedLegacyBuildStart = (
  projectId?: string | number | null,
  sessionId?: string | null,
) => {
  if (!canUseSessionStorage()) return 0;

  const value = window.sessionStorage.getItem(getLegacyBuildStartKey(projectId, sessionId));
  const startedAt = Number(value);
  if (!Number.isFinite(startedAt) || startedAt <= 0) return 0;
  if (Date.now() - startedAt > LEGACY_BUILD_START_MAX_AGE_MS) {
    window.sessionStorage.removeItem(getLegacyBuildStartKey(projectId, sessionId));
    return 0;
  }
  return startedAt;
};

export const clearRememberedLegacyBuildStart = (
  projectId?: string | number | null,
  sessionId?: string | null,
) => {
  if (!canUseSessionStorage()) return;
  window.sessionStorage.removeItem(getLegacyBuildStartKey(projectId, sessionId));
};
